import * as React from 'react';
// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client'
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { App } from 'App';
import theme from 'theme';
import { BrowserRouter } from "react-router-dom"
import { AuthProvider } from 'Auth';
import { ModalProvider } from 'Modals';
import { DrawerProvider } from 'Drawer';
import { AppProvider } from 'App/AppContext';
import { SnackbarProvider } from 'Components/Snackbar';
import packageJson from '../package.json';
import { CartProvider } from 'Contexts/Cart';
import './output.css'
import registerServiceWorker from './serviceWorker';
import { NotificationsProvider } from 'Contexts/Notifications';
// import { PROJECT_KEY } from 'Config';

global.appVersion = packageJson.version;

// if (PROJECT_KEY) {
//   const base = process.env.PUBLIC_URL || "";
//   const appleTouch = document.getElementById("apple-touch-icon");
//   if (appleTouch) {
//     appleTouch.href = `${base}/${PROJECT_KEY}/apple-touch-icon.png`;
//   }
//   const favicon32 = document.getElementById("favicon-32");
//   if (favicon32) {
//     favicon32.href = `${base}/${PROJECT_KEY}/favicon-32x32.png`;
//   }
//   const favicon16 = document.getElementById("favicon-16");
//   if (favicon16) {
//     favicon16.href = `${base}/${PROJECT_KEY}/favicon-16x16.png`;
//   }
//   const siteManifest = document.getElementById("site-manifest");
//   if (siteManifest) {
//     siteManifest.href = `${base}/${PROJECT_KEY}/site.webmanifest`;
//   }

//   const manifestJson = document.getElementById("manifest-json");
//   if (manifestJson) {
//     manifestJson.href = `${base}/${PROJECT_KEY}/manifest.json`;
//   }
// }

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <BrowserRouter basename="/" future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <SnackbarProvider>
      <AppProvider>
        <AuthProvider>
          <DrawerProvider>
            <ModalProvider>
              <CartProvider>
                <NotificationsProvider>
                  <ThemeProvider theme={theme}>
                    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
                    <CssBaseline />
                    <App />
                  </ThemeProvider>
                </NotificationsProvider>
              </CartProvider>
            </ModalProvider>
          </DrawerProvider>
        </AuthProvider>
      </AppProvider>
    </SnackbarProvider>
  </BrowserRouter>
)

registerServiceWorker()
